// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  project: 'apssbaliza2',
  sharingAvailable: true,
  pageTile: 'Meteorologia - Baliza 2',
  stations: [
    {
      project: 'apsssetubal',
      name: 'Porto de Setúbal',
      url: 'https://apss.hidromod.com/meteoapss/setubal/#/',
    },
    {
      project: 'apsstroia',
      name: 'Tróia',
      url: 'https://apss.hidromod.com/meteoapss/troia/#/',
    },
    {
      project: 'apsssesimbra',
      name: 'Sesimbra',
      url: 'https://apss.hidromod.com/meteoapss/sesimbra/#/',
    },
    {
      project: 'apsslisnave',
      name: 'Lisnave',
      url: 'https://apss.hidromod.com/meteoapss/lisnave/#/',
    },
    {
      project: 'apssclubenaval',
      name: 'Clube Naval',
      url: 'https://apss.hidromod.com/meteoapss/clubenaval/#/',
    },
    {
      project: 'apsstremnaval',
      name: 'Trem Naval',
      url: 'https://apss.hidromod.com/meteoapss/tremnaval/#/',
    }
  ],
};
